<template>
  <div class="input-text-type-1">
    <label>{{ this.inputText }}</label>
    <input
      v-model="inputTemp"
      type="text"
      :placeholder="placeholder"
      :maxlength="maxlength"
    />
  </div>
</template>

<script>
export default {
  name: 'input-text-type-1',
  props: {
    inputText: {
      default: 'Input Text',
      type: String
    },
    input: {
      default: '',
      type: String
    },
    maxlength: {
      default: 100,
      type: Number
    },
    placeholder: {
      default: 'INPUT TEXT',
      type: String
    }
  },
  data() {
    return {
      inputTemp: ''
    }
  },
  created() {
    this.inputTemp = this.input
  },
  updated() {
    this.$emit('model', this.inputTemp)
  }
}
</script>

<style lang="scss" scoped>
.input-text-type-1 {
  label {
    font-weight: 600;
  }
  input {
    padding: 0 10px;
    width: 100%;
    height: 50px;
    font-size: 14px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 1px;
    color: #000000;
    margin: 10px 0 0 0;
    background-color: #ffffff;
    border: solid 1px #e7e7e7;
    outline: none;
  }
}
</style>
